import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  NextTier as NextTierComponent,
  NextTierProps,
} from "../../components/NextTier/NextTier";
import { getRewardStats } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getRewardStats as getRewardStatsSelector,
} from "../../reducers/methods";

interface NextTierContainerProps extends NextTierProps {
  campaignId: string;
  getRewardStats: typeof getRewardStats;
  rewardStats: StoreState["reward"]["rewardStats"];
}

class NextTier extends React.PureComponent<NextTierContainerProps> {
  componentDidMount() {
    const { data, campaignId, getRewardStats, rewardStats } = this.props;
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      const userEmailAddress = get(data, "customer.email");
      const rewardStatsRetrieved = get(rewardStats, "retrieved") !== false;

      if (campaignId && userEmailAddress && !rewardStatsRetrieved) {
        getRewardStats({ campaignId, email: userEmailAddress });
      }
    }
  }

  render() {
    // tslint:disable-next-line:no-any
    return <NextTierComponent {...(this.props as any)} />;
  }
}

const mapStateToProps = (state: StoreState) => ({
  campaignId: getCampaignId(state),
  rewardStats: getRewardStatsSelector(state),
});

export default connect(mapStateToProps, { getRewardStats })(NextTier);
